export default {
  name: "Companies",
  single: "Company",

  api: {
    company: {
      name: {
        notNull: "Give the company a name",
      },
    }
  },
}
